import { Img } from "components";
import TextArea from "../components/TextArea";
import AvatarVideo from "../components/AvatarVideo";
import Lottie from "lottie-react";
import DownArrow from "assets/images/DownArrow.json";
import Wrapper from "../components/Wrapper";
import { Link } from "react-router-dom";
import classNames from 'classnames';

const videoLinks:any = [
    { url: "https://soomuch.blob.core.windows.net/data-soomuch/DemoContent/AvatarVideos/checkout.mp4" }
]

const NewCheckout = () => {
    return (
        <div className={`relative flex justify-center items-center min-w-screen min-h-screen overflow-clip bg-[url(/public/images/soomuch-demo/BlueRadialBG.svg)] bg-no-repeat bg-cover bg-center`}>
            <div className={`absolute top-[1.5vh] font-manrope pt-[2vh] px-[10vh] pb-[2vh] flex flex-col justify-between w-full z-[1000]`}>
                <div>
                    <div className="grid grid-cols-12 gap-4 w-full">
                        <div className="col-span-2 flex flex-col gap-4 justify-end">
                            <Link to={"/explore"}>
                                <Img src="images/soomuch-demo/logo.svg" className="w-[40vh]" />
                            </Link>
                            <div>
                                <Img src="images/soomuch-demo/Patent.svg" className="w-[18vh]" />
                            </div>
                        </div>
                        <div className={`col-span-8 `}></div>
                        <div className="col-span-2  flex justify-end">
                            {!!videoLinks?.length && Array.isArray(videoLinks) ? <AvatarVideo videoLinks={videoLinks} /> : (!!videoLinks ? videoLinks : <Img src={"/images/soomuch-demo/VideoLoader.png"} className="w-[18vh] h-[18vh] object-top object-cover rounded-lg shadow-2xl shadow-[gray]" />)}
                        </div>
                    </div>
                </div>
            </div>
            <div className="relative flex justify-center items-center min-w-[90%] min-h-screen  bg-[url(/public/images/soomuch-demo/PurpelRadialBG.svg)] bg-no-repeat bg-cover bg-center animate-scaleIn animation-delay-0">
                <div className="absolute inset-0  flex justify-center items-center w-full h-full animate-spin-slow-15 animation-delay-1000">

                    <div className="absolute inset-x-0 -top-[30vh] flex items-center justify-center animate-spin-reverse-slow-15">
                        <Img src="images/soomuch-demo/animation/micvideo.svg" className="w-[10vh]" />
                    </div>
                    <div className="absolute inset-y-0 left-[0.5vh] flex items-center justify-center animate-spin-reverse-slow-15">
                        <Img src="images/soomuch-demo/animation/micvoice.svg" className="w-[10vh]" />
                    </div>
                    <div className="absolute inset-y-0 right-[0.5vh] flex items-center justify-center animate-spin-reverse-slow-15">
                        <Img src="images/soomuch-demo/animation/micvideo.svg" className="w-[10vh]" />
                    </div>
                    <div className="absolute inset-x-0 -bottom-[30vh] flex items-center justify-center animate-spin-reverse-slow-15">
                        <Img src="images/soomuch-demo/animation/micvoice.svg" className="w-[10vh]" />
                    </div>
                </div>

                <div className="relative flex justify-center items-center w-[85%] min-h-screen bg-[url(/public/images/soomuch-demo/PurpelRadialBG.svg)] bg-no-repeat bg-cover bg-center animate-scaleIn animation-delay-500">
                    <div className="absolute inset-0  flex justify-center items-center w-full h-full animate-spin-slow-20 animation-delay-1500">

                        <div className="absolute top-[0vh] left-[22vh] flex items-center justify-center animate-spin-reverse-slow-20">
                            <Img src="images/soomuch-demo/animation/call.svg" className="w-[6vh]" />
                        </div>
                        <div className="absolute inset-x-0 -top-[16vh] flex items-center justify-center animate-spin-reverse-slow-20">
                            <Img src="images/soomuch-demo/animation/checklist.svg" className="w-[6vh]" />
                        </div>
                        <div className="absolute top-0 right-[22vh] flex items-center justify-center animate-spin-reverse-slow-20">
                            <Img src="images/soomuch-demo/animation/penpaper.svg" className="w-[6vh]" />
                        </div>
                        <div className="absolute inset-y-0 left-[2vh] flex items-center justify-center animate-spin-reverse-slow-20">
                            <Img src="images/soomuch-demo/animation/aplus.svg" className="w-[6vh]" />
                        </div>
                        <div className="absolute inset-y-0 right-[2vh] flex items-center justify-center animate-spin-reverse-slow-20">
                            <Img src="images/soomuch-demo/animation/penpaper2.svg" className="w-[6vh]" />
                        </div>
                        <div className="absolute bottom-[0vh] left-[22vh] flex items-center justify-center animate-spin-reverse-slow-20">
                            <Img src="images/soomuch-demo/animation/folderpaper.svg" className="w-[6vh]" />
                        </div>
                        <div className="absolute inset-x-0 -bottom-[16vh] flex items-center justify-center animate-spin-reverse-slow-20">
                            <Img src="images/soomuch-demo/animation/pintask.svg" className="w-[6vh]" />
                        </div>
                        <div className="absolute right-[22vh] bottom-0 flex items-center justify-center animate-spin-reverse-slow-20">
                            <Img src="images/soomuch-demo/animation/family.svg" className="w-[6vh]" />
                        </div>
                    </div>

                    <div className="relative flex justify-center items-center w-[80%] min-h-screen bg-[url(/public/images/soomuch-demo/PurpelRadialBG.svg)] bg-no-repeat bg-cover bg-center animate-scaleIn animation-delay-1000">
                        <div className="absolute inset-0  flex justify-center items-center w-full h-full animate-spin-slow-30 animation-delay-2000">

                            <div className="absolute inset-x-0 -top-[3.5vh] flex items-center justify-center animate-spin-reverse-slow-30">
                                <Img src="images/soomuch-demo/animation/Aa.svg" className="w-[7vh]" />
                            </div>
                            <div className="absolute inset-y-0 left-[3vh] flex items-center justify-center animate-spin-reverse-slow-30">
                                <Img src="images/soomuch-demo/animation/hindiAA.svg" className="w-[7vh]" />
                            </div>
                            <div className="absolute inset-y-0 right-[3vh] flex items-center justify-center animate-spin-reverse-slow-30">
                                <Img src="images/soomuch-demo/animation/teluguAA.svg" className="w-[7vh]" />
                            </div>
                            <div className="absolute inset-x-0 -bottom-[3.5vh] flex items-center justify-center animate-spin-reverse-slow-30">
                                <Img src="images/soomuch-demo/animation/Aa.svg" className="w-[7vh]" />
                            </div>
                        </div>

                        <div className="relative flex justify-center items-center w-[87vh] h-[87vh]">
                            <div className="relative flex justify-center items-center w-[100%] h-[100%] bg-[url('/public/images/soomuch-demo/PurpelRadialBG.svg')] bg-no-repeat bg-cover bg-center animate-scaleIn animation-delay-1500">
                                <div className="absolute inset-0  flex justify-center items-center w-full h-full bg-[url('/public/images/soomuch-demo/PurpelRadialBG.svg')] bg-no-repeat bg-cover bg-center animate-spin-slow-40 animation-delay-2500">

                                    <div className="absolute inset-x-0 top-[2vh] flex items-center justify-center animate-spin-reverse-slow-40">
                                        <Img src="images/soomuch-demo/animation/fb.svg" className="w-[7vh]" />
                                    </div>
                                    <div className="absolute inset-y-0 left-[2vh] flex items-center justify-center animate-spin-reverse-slow-40">
                                        <Img src="images/soomuch-demo/animation/ig.svg" className="w-[7vh]" />
                                    </div>
                                    <div className="absolute inset-y-0 right-[2vh] flex items-center justify-center animate-spin-reverse-slow-40">
                                        <Img src="images/soomuch-demo/animation/yt.svg" className="w-[7vh]" />
                                    </div>
                                    <div className="absolute inset-x-0 bottom-[2vh] flex items-center justify-center animate-spin-reverse-slow-40">
                                        <Img src="images/soomuch-demo/animation/gb.svg" className="w-[7vh]" />
                                    </div>
                                </div>

                                <div className="z-[1300] font-manrope flex flex-col justify-center items-center gap-2 text-center relative w-[62vh] h-[62vh] bg-[url('/public/images/soomuch-demo/DarkPurpelRadialBG.svg')] bg-no-repeat bg-cover bg-center">
                                    <p className="text-[white] text-[4.5vh] font-meriendaB">Checkout Live Website</p>
                                    <p className="text-[#F5F5F5] text-[2vh]">
                                        This is the responsive demo, the exact way your <br /> school’s site will adapt to phones, tablets, and <br /> desktops.
                                    </p>
                                   <a href={"https://newdemo.soomuch.ai/"}><Img src="images/soomuch-demo/animation/button.svg" className="cursor-pointer w-[30vh]" /></a>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>

    );
};

export default NewCheckout;



// <div className={`animate-scaleIn relative flex justify-center items-center min-w-screen min-h-screen bg-[url(/public/images/soomuch-demo/BlueRadialBG.svg)] bg-no-repeat bg-cover bg-center`}>
//     <div className={`absolute top-[2vh] font-manrope pt-[2vh] px-[10vh] pb-[2vh] flex flex-col justify-between w-full z-[1200]`}>
//     <div>
//         <div className="grid grid-cols-12 gap-4 w-full">
//             <div className="col-span-2 flex flex-col gap-4 justify-end">
//                 <Link to={"/explore"}>
//                     <Img src="images/soomuch-demo/logo.svg" className="w-[40vh]" />
//                 </Link>
//                 <div>
//                     <Img src="images/soomuch-demo/Patent.svg" className="w-[18vh]" />
//                 </div>
//             </div>
//             <div className={`col-span-8 `}></div>
//             <div className="col-span-2  flex justify-end">
//                 {!!videoLinks?.length && Array.isArray(videoLinks) ? <AvatarVideo videoLinks={videoLinks} /> : (!!videoLinks ? videoLinks : <Img src={"/images/soomuch-demo/VideoLoader.png"} className="w-[18vh] h-[18vh] object-top object-cover rounded-lg shadow-2xl shadow-[gray]" />)}
//             </div>
//         </div>
//     </div>
// </div>
//     <div className="relative flex justify-center items-center min-w-[90%] min-h-screen  bg-[url(/public/images/soomuch-demo/PurpelRadialBG.svg)] bg-no-repeat bg-cover bg-center animate-scaleIn">
//             {/* first circle */}
//         <div className="absolute inset-0 z-[1] flex justify-center items-center w-full h-full animate-spin-slow-15">

//             <div className="absolute inset-x-0 -top-[44vh] flex items-center justify-center animate-spin-reverse-slow-15">
//                 <Img src="images/soomuch-demo/animation/micvideo.svg" className="w-[10vh]" />
//             </div>
//             <div className="absolute inset-y-0 left-[3vh] flex items-center justify-center animate-spin-reverse-slow-15">
//                 <Img src="images/soomuch-demo/animation/micvoice.svg" className="w-[10vh]" />
//             </div>
//             <div className="absolute inset-y-0 right-[3vh] flex items-center justify-center animate-spin-reverse-slow-15">
//                 <Img src="images/soomuch-demo/animation/micvideo.svg" className="w-[10vh]" />
//             </div>
//             <div className="absolute inset-x-0 -bottom-[44vh] flex items-center justify-center animate-spin-reverse-slow-15">
//                 <Img src="images/soomuch-demo/animation/micvoice.svg" className="w-[10vh]" />
//             </div>
//         </div>

//         <div className="relative flex justify-center items-center w-[85%] min-h-screen bg-[url(/public/images/soomuch-demo/PurpelRadialBG.svg)] bg-no-repeat bg-cover bg-center">
//                 {/* second circle */}
//             <div className="absolute inset-0 z-[1] flex justify-center items-center w-full h-full animate-spin-slow-20">

//                 <div className="absolute top-[0vh] left-[22vh] flex items-center justify-center animate-spin-reverse-slow-20">
//                     <Img src="images/soomuch-demo/animation/call.svg" className="w-[6vh]" />
//                 </div>
//                 <div className="absolute inset-x-0 -top-[28vh] flex items-center justify-center animate-spin-reverse-slow-20">
//                     <Img src="images/soomuch-demo/animation/checklist.svg" className="w-[6vh]" />
//                 </div>
//                 <div className="absolute top-0 right-[22vh] flex items-center justify-center animate-spin-reverse-slow-20">
//                     <Img src="images/soomuch-demo/animation/penpaper.svg" className="w-[6vh]" />
//                 </div>
//                 <div className="absolute inset-y-0 left-[5vh] flex items-center justify-center animate-spin-reverse-slow-20">
//                     <Img src="images/soomuch-demo/animation/aplus.svg" className="w-[6vh]" />
//                 </div>
//                 <div className="absolute inset-y-0 right-[5vh] flex items-center justify-center animate-spin-reverse-slow-20">
//                     <Img src="images/soomuch-demo/animation/penpaper2.svg" className="w-[6vh]" />
//                 </div>
//                 <div className="absolute bottom-[0vh] left-[22vh] flex items-center justify-center animate-spin-reverse-slow-20">
//                     <Img src="images/soomuch-demo/animation/folderpaper.svg" className="w-[6vh]" />
//                 </div>
//                 <div className="absolute inset-x-0 -bottom-[28vh] flex items-center justify-center animate-spin-reverse-slow-20">
//                     <Img src="images/soomuch-demo/animation/pintask.svg" className="w-[6vh]" />
//                 </div>
//                 <div className="absolute right-[22vh] bottom-0 flex items-center justify-center animate-spin-reverse-slow-20">
//                     <Img src="images/soomuch-demo/animation/family.svg" className="w-[6vh]" />
//                 </div>
//             </div>

//             <div className="relative flex justify-center items-center w-[80%] min-h-screen overflow-clip bg-[url(/public/images/soomuch-demo/PurpelRadialBG.svg)] bg-no-repeat bg-cover bg-center">
//                     {/* third circle */}
//                 <div className="absolute inset-0 z-[1] flex justify-center items-center w-full h-full animate-spin-slow-30">

//                     <div className="absolute inset-x-0 -top-[10vh] flex items-center justify-center animate-spin-reverse-slow-30">
//                         <Img src="images/soomuch-demo/animation/Aa.svg" className="w-[6vh]" />
//                     </div>
//                     <div className="absolute inset-y-0 left-[5vh] flex items-center justify-center animate-spin-reverse-slow-30">
//                         <Img src="images/soomuch-demo/animation/hindiAA.svg" className="w-[6vh]" />
//                     </div>
//                     <div className="absolute inset-y-0 right-[5vh] flex items-center justify-center animate-spin-reverse-slow-30">
//                         <Img src="images/soomuch-demo/animation/teluguAA.svg" className="w-[6vh]" />
//                     </div>
//                     <div className="absolute inset-x-0 -bottom-[10vh] flex items-center justify-center animate-spin-reverse-slow-30">
//                         <Img src="images/soomuch-demo/animation/Aa.svg" className="w-[6vh]" />
//                     </div>
//                 </div>

//                 <div className="relative flex justify-center items-center w-[95vh] h-[95vh]">
//                     <div className="relative flex justify-center items-center w-[95vw] h-[95vh] bg-[url('/public/images/soomuch-demo/PurpelRadialBG.svg')] bg-no-repeat bg-cover bg-center">
//                         {/* forth circle */}
//                         <div className="absolute inset-0 z-[1] flex justify-center items-center w-full h-full bg-[url('/public/images/soomuch-demo/PurpelRadialBG.svg')] bg-no-repeat bg-cover bg-center animate-spin-slow-40">

//                             <div className="absolute inset-x-0 top-[4vh] flex items-center justify-center animate-spin-reverse-slow-40">
//                                 <Img src="images/soomuch-demo/animation/fb.svg" className="w-[7vh]" />
//                             </div>
//                             <div className="absolute inset-y-0 left-[4vh] flex items-center justify-center animate-spin-reverse-slow-40">
//                                 <Img src="images/soomuch-demo/animation/ig.svg" className="w-[7vh]" />
//                             </div>
//                             <div className="absolute inset-y-0 right-[4vh] flex items-center justify-center animate-spin-reverse-slow-40">
//                                 <Img src="images/soomuch-demo/animation/yt.svg" className="w-[7vh]" />
//                             </div>
//                             <div className="absolute inset-x-0 bottom-[4vh] flex items-center justify-center animate-spin-reverse-slow-40">
//                                 <Img src="images/soomuch-demo/animation/gb.svg" className="w-[7vh]" />
//                             </div>
//                         </div>

//                         <div className="font-manrope flex flex-col justify-center items-center gap-2 text-center z-[2] w-[65vh] h-[65vh] bg-[url('/public/images/soomuch-demo/DarkPurpelRadialBG.svg')] bg-no-repeat bg-cover bg-center">
//                             <p className="text-[white] text-[4.5vh] font-manropeB">Checkout Live Website</p>
//                             <p className="text-[#F5F5F5] text-[2vh]">
//                                 This is the responsive demo, the exact way your <br /> school’s site will adapt to phones, tablets, and <br /> desktops.
//                             </p>
//                             <Img src="images/soomuch-demo/animation/button.svg" className="cursor-pointer w-[30vh]" />
//                         </div>

//                     </div>
//                 </div>

//             </div>
//         </div>
//     </div>
// </div>

// first animation

// <div className={`relative flex justify-center items-center min-w-screen min-h-screen overflow-clip bg-[url(/public/images/soomuch-demo/BlueRadialBG.svg)] bg-no-repeat bg-cover bg-center`}>
//     <div className={`absolute top-[2vh] font-manrope pt-[2vh] px-[10vh] pb-[2vh] flex flex-col justify-between w-full z-[1200]`}>
//         <div>
//             <div className="grid grid-cols-12 gap-4 w-full">
//                 <div className="col-span-2 flex flex-col gap-4 justify-end">
//                     <Link to={"/explore"}>
//                         <Img src="images/soomuch-demo/logo.svg" className="w-[40vh]" />
//                     </Link>
//                     <div>
//                         <Img src="images/soomuch-demo/Patent.svg" className="w-[18vh]" />
//                     </div>
//                 </div>
//                 <div className={`col-span-8 `}></div>
//                 <div className="col-span-2  flex justify-end">
//                     {!!videoLinks?.length && Array.isArray(videoLinks) ? <AvatarVideo videoLinks={videoLinks} /> : (!!videoLinks ? videoLinks : <Img src={"/images/soomuch-demo/VideoLoader.png"} className="w-[18vh] h-[18vh] object-top object-cover rounded-lg shadow-2xl shadow-[gray]" />)}
//                 </div>
//             </div>
//         </div>
//     </div>
//     <div className="relative flex justify-center items-center min-w-[90%] min-h-screen  bg-[url(/public/images/soomuch-demo/PurpelRadialBG.svg)] bg-no-repeat bg-cover bg-center animate-scaleIn animation-delay-2500">
//         <div className="absolute inset-0 z-[1] flex justify-center items-center w-full h-full animate-spin-slow-15 animation-delay-2000">

//             <div className="absolute inset-x-0 -top-[44vh] flex items-center justify-center animate-spin-reverse-slow-15">
//                 <Img src="images/soomuch-demo/animation/micvideo.svg" className="w-[10vh]" />
//             </div>
//             <div className="absolute inset-y-0 left-[3vh] flex items-center justify-center animate-spin-reverse-slow-15">
//                 <Img src="images/soomuch-demo/animation/micvoice.svg" className="w-[10vh]" />
//             </div>
//             <div className="absolute inset-y-0 right-[3vh] flex items-center justify-center animate-spin-reverse-slow-15">
//                 <Img src="images/soomuch-demo/animation/micvideo.svg" className="w-[10vh]" />
//             </div>
//             <div className="absolute inset-x-0 -bottom-[44vh] flex items-center justify-center animate-spin-reverse-slow-15">
//                 <Img src="images/soomuch-demo/animation/micvoice.svg" className="w-[10vh]" />
//             </div>
//         </div>

//         <div className="relative flex justify-center items-center w-[85%] min-h-screen bg-[url(/public/images/soomuch-demo/PurpelRadialBG.svg)] bg-no-repeat bg-cover bg-center animate-scaleIn animation-delay-1500">
//             <div className="absolute inset-0 z-[1] flex justify-center items-center w-full h-full animate-spin-slow-20 animation-delay-1000">

//                 <div className="absolute top-[0vh] left-[22vh] flex items-center justify-center animate-spin-reverse-slow-20">
//                     <Img src="images/soomuch-demo/animation/call.svg" className="w-[6vh]" />
//                 </div>
//                 <div className="absolute inset-x-0 -top-[28vh] flex items-center justify-center animate-spin-reverse-slow-20">
//                     <Img src="images/soomuch-demo/animation/checklist.svg" className="w-[6vh]" />
//                 </div>
//                 <div className="absolute top-0 right-[22vh] flex items-center justify-center animate-spin-reverse-slow-20">
//                     <Img src="images/soomuch-demo/animation/penpaper.svg" className="w-[6vh]" />
//                 </div>
//                 <div className="absolute inset-y-0 left-[5vh] flex items-center justify-center animate-spin-reverse-slow-20">
//                     <Img src="images/soomuch-demo/animation/aplus.svg" className="w-[6vh]" />
//                 </div>
//                 <div className="absolute inset-y-0 right-[5vh] flex items-center justify-center animate-spin-reverse-slow-20">
//                     <Img src="images/soomuch-demo/animation/penpaper2.svg" className="w-[6vh]" />
//                 </div>
//                 <div className="absolute bottom-[0vh] left-[22vh] flex items-center justify-center animate-spin-reverse-slow-20">
//                     <Img src="images/soomuch-demo/animation/folderpaper.svg" className="w-[6vh]" />
//                 </div>
//                 <div className="absolute inset-x-0 -bottom-[28vh] flex items-center justify-center animate-spin-reverse-slow-20">
//                     <Img src="images/soomuch-demo/animation/pintask.svg" className="w-[6vh]" />
//                 </div>
//                 <div className="absolute right-[22vh] bottom-0 flex items-center justify-center animate-spin-reverse-slow-20">
//                     <Img src="images/soomuch-demo/animation/family.svg" className="w-[6vh]" />
//                 </div>
//             </div>

//             <div className="relative flex justify-center items-center w-[80%] min-h-screen bg-[url(/public/images/soomuch-demo/PurpelRadialBG.svg)] bg-no-repeat bg-cover bg-center animate-scaleIn animation-delay-1000">
//                 <div className="absolute inset-0 z-[1] flex justify-center items-center w-full h-full animate-spin-slow-30 animation-delay-500">

//                     <div className="absolute inset-x-0 -top-[10vh] flex items-center justify-center animate-spin-reverse-slow-30">
//                         <Img src="images/soomuch-demo/animation/Aa.svg" className="w-[6vh]" />
//                     </div>
//                     <div className="absolute inset-y-0 left-[5vh] flex items-center justify-center animate-spin-reverse-slow-30">
//                         <Img src="images/soomuch-demo/animation/hindiAA.svg" className="w-[6vh]" />
//                     </div>
//                     <div className="absolute inset-y-0 right-[5vh] flex items-center justify-center animate-spin-reverse-slow-30">
//                         <Img src="images/soomuch-demo/animation/teluguAA.svg" className="w-[6vh]" />
//                     </div>
//                     <div className="absolute inset-x-0 -bottom-[10vh] flex items-center justify-center animate-spin-reverse-slow-30">
//                         <Img src="images/soomuch-demo/animation/Aa.svg" className="w-[6vh]" />
//                     </div>
//                 </div>

//                 <div className="relative flex justify-center items-center w-[95vh] h-[95vh]">
//                     <div className="relative flex justify-center items-center w-[95vw] h-[95vh] bg-[url('/public/images/soomuch-demo/PurpelRadialBG.svg')] bg-no-repeat bg-cover bg-center animate-scaleIn">
//                         <div className="absolute inset-0 z-[1] flex justify-center items-center w-full h-full bg-[url('/public/images/soomuch-demo/PurpelRadialBG.svg')] bg-no-repeat bg-cover bg-center animate-spin-slow-40">

//                             <div className="absolute inset-x-0 top-[4vh] flex items-center justify-center animate-spin-reverse-slow-40">
//                                 <Img src="images/soomuch-demo/animation/fb.svg" className="w-[7vh]" />
//                             </div>
//                             <div className="absolute inset-y-0 left-[4vh] flex items-center justify-center animate-spin-reverse-slow-40">
//                                 <Img src="images/soomuch-demo/animation/ig.svg" className="w-[7vh]" />
//                             </div>
//                             <div className="absolute inset-y-0 right-[4vh] flex items-center justify-center animate-spin-reverse-slow-40">
//                                 <Img src="images/soomuch-demo/animation/yt.svg" className="w-[7vh]" />
//                             </div>
//                             <div className="absolute inset-x-0 bottom-[4vh] flex items-center justify-center animate-spin-reverse-slow-40">
//                                 <Img src="images/soomuch-demo/animation/gb.svg" className="w-[7vh]" />
//                             </div>
//                         </div>

//                         <div className="font-manrope flex flex-col justify-center items-center gap-2 text-center z-[2] w-[65vh] h-[65vh] bg-[url('/public/images/soomuch-demo/DarkPurpelRadialBG.svg')] bg-no-repeat bg-cover bg-center">
//                             <p className="text-[white] text-[4.5vh] font-manropeB">Checkout Live Website</p>
//                             <p className="text-[#F5F5F5] text-[2vh]">
//                                 This is the responsive demo, the exact way your <br /> school’s site will adapt to phones, tablets, and <br /> desktops.
//                             </p>
//                             <Img src="images/soomuch-demo/animation/button.svg" className="cursor-pointer w-[30vh]" />
//                         </div>

//                     </div>
//                 </div>

//             </div>
//         </div>
//     </div>
// </div>

// second animation
